import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { departamentosMapper } from '@/mappers';
import { loadAbort, buildStrapiUrl } from '@/utils';
import type { DepartamentosPageModel, StrapiSingleResponseModel } from '@/interfaces/model';
import type { DepartamentosPage, StrapiBaseRequest } from '@/interfaces/strapi';

export const getDepartamentos = (params: StrapiBaseRequest): UseApiCall<DepartamentosPage> => {
	const controller = loadAbort();

	const { fields, populate } = params ?? {};

	console.log('populate', populate);
	const url = buildStrapiUrl({
		base: '/departamento',
		fields,
		populate,
	});

	return {
		call: strapiInstance.get<DepartamentosPage>(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const parsed = JSON.parse(raw) as StrapiSingleResponseModel<DepartamentosPageModel>;
					return departamentosMapper(parsed.data);
				},
			],
		}),
		controller,
	};
};
